import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import RelationDataTable from '../datatable/RelationDataTable';
import Thumbnail from '../thumbnail/Thumbnail';
import { COLUMN_STYLE, getColumnStyle } from '../datatable/util';
import Constants from '../../config/constants';
import { searchLuminanireByText } from '../../redux/luminaire/luminaire_actions';
import {
  addLightingSetLuminaire,
  editLightingSetLuminaire,
  removeLightingSetLuminaire,
  removeTobeCreatedLuminaire,
  addToBeCreatedLuminaire,
  editTobeCreatedLuminaire
} from '../../redux/luminaire/lightingset_actions';
import { defaultRejectHandler } from '../../utils/utility';

export class LuminaireDataTable extends React.Component {
  constructor(props) {
    super(props);
    const { t } = props;

    this.search = {
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      page: null,
      sorted: null,
      filtered: null,
    };

    const textColumn = getColumnStyle(COLUMN_STYLE.text);
    const coeColumn = getColumnStyle(COLUMN_STYLE.coefficient);
    const decimalColumn = getColumnStyle(COLUMN_STYLE.decimal);

    this.columns = [
      {
        Header: '',
        accessor: 'bulb.thumbnail',
        Cell: row => <Thumbnail img={row.value} />,
        ...getColumnStyle(COLUMN_STYLE.thumbnail),
      },
      {
        Header: () => <b>{t('name')}</b>,
        accessor: 'bulb.name',
        ...textColumn,
        entity: {
          list: (text, page) => searchLuminanireByText(text, page)
            .then(response => response.data.map((luminaire) => ({label: luminaire.name, value: String(luminaire.id), original: luminaire}))),
          create: null,
        },
      },
      {
        Header: () => <b>{t('power (W)')}</b>,
        accessor: 'bulb.power_required',
        ...coeColumn,
        width: 120,
      },
      {
        Header: () => <b>{t('quantity')}</b>,
        accessor: 'quantity',
        ...decimalColumn,
        width: 80,
        attr: {
          type: 'number',
          isRequired: true,
          props: { min: 1 },
        },
      },
      {
        Header: () => <b>{t('total power (W)')}</b>,
        accessor: 'power_required',
        ...coeColumn,
        width: 140,
      },
    ];

    this.state = {
      categoryOption: 'all',
      selectedItem: null,
    };
  }

  updateSortFilter(filter, state, category) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.setState({ categoryOption: category });
  }

  editItem(item) {
    this.setState({
        isShowEditModal: true,
        selectedItem: item.original,
      },
      () => {
        if (this.props.onEditItem) {
          this.props.onEditItem(this.state.selectedItem);
        }
      },
    );
  }

  render() {
    const {
      categoryOption,
      selectedItem: item,
    } = this.state;

    const {
      lightingSetId,
      filtered,
      filteredCount,
      isLoading,
      addLuminaire,
      removeLuminaire,
      editLuminaire,
      isLuminaireAdding,
      isLuminaireEditing,
      isLuminaireRemoving,
      t,

      addTobeCreatedLuminaire,
      editTobeCreatedLuminaire,
      removeTobeCreatedLuminaire,
      mode,
    } = this.props;

    const relationship = {
      create: (({ name, entityId, quantity, original }) => {
        if (mode === 'edit') { 
          addLuminaire(lightingSetId, entityId, quantity);
        } else{
          addTobeCreatedLuminaire(quantity, original, this.props.luminaires);
        }
      }).bind(this),
      delete: (id, rel) => {
        if (mode === 'edit') { 
          removeLuminaire(id, lightingSetId);
        } else{
          removeTobeCreatedLuminaire(rel.bulb.id);
        }
      },
      edit: ({ id, quantity, bulb }) => {
        if (mode === 'edit') { 
          editLuminaire(id, quantity);
        } else{
          editTobeCreatedLuminaire(bulb.id, quantity);
        }
      },
      isCreating: isLuminaireAdding,
      isEditing: isLuminaireEditing,
      isDeleting: isLuminaireRemoving,
    };

    return (
      <div>
        <div style={{ backgroundColor: 'white' }}>
          <RelationDataTable
            columns={this.columns}
            data={this.props.luminaires}
            relationship={relationship}
            relationshipNameAccessor={item => item.bulb.name}
            classNamePrefix="select-lightingset-luminaire"
            onActionEdit={item => this.editItem(item)}
            onActionDelete={item => this.setState({ isShowDeleteModal: true, selectedItem: item.original })}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state, categoryOption)}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isLuminaireAdding: state.lighting.lightingset.isLuminaireAdding,
  isLuminaireEditing: state.lighting.lightingset.isLuminaireEditing,
  isLuminaireRemoving: state.lighting.lightingset.isLuminaireRemoving,
});

const mapDispatchToProps = dispatch => ({
  addLuminaire: (lightingSetId, luminaireId, quantity) => defaultRejectHandler(dispatch(addLightingSetLuminaire(lightingSetId, luminaireId, quantity))),
  addTobeCreatedLuminaire: (quantity, luminaire,tobeCreatedluminairearry) => defaultRejectHandler(dispatch(addToBeCreatedLuminaire(quantity, luminaire, tobeCreatedluminairearry))),
  removeLuminaire: (lightingSetLuminaireId, lightingSetId) => defaultRejectHandler(dispatch(removeLightingSetLuminaire(lightingSetLuminaireId, lightingSetId))),
  removeTobeCreatedLuminaire: (bulbId) => defaultRejectHandler(dispatch(removeTobeCreatedLuminaire(bulbId))),
  editLuminaire: (lightingSetLuminaireId, quantity) => defaultRejectHandler(dispatch(editLightingSetLuminaire(lightingSetLuminaireId, quantity))),
  editTobeCreatedLuminaire: (bulbId, quantity) => defaultRejectHandler(dispatch(editTobeCreatedLuminaire(bulbId, quantity))),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(LuminaireDataTable),
);



// WEBPACK FOOTER //
// ./src/components/light/LuminaireDataTable.js